<!--
 * @Author: your name
 * @Date: 2021-11-02 13:37:56
 * @LastEditTime: 2026-04-30 14:25:13
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: In User Settings Edit
 * @FilePath: /my-activation/src/couponCenter/index.vue
-->
<template>
  <div class="mycoupon">
    <div id="qrcode" v-show="showQR" @click="handleClose()"></div>
    <!-- <div v-if="showQR" class="maskqr" @click="handleClose()"></div> -->
    <div class="titles">
      <div
        class="tabs"
        @click="handleTab(1)"
        :style="{
          color: active === 1 ? '#F2553D' : '#757575',
          borderBottom: active === 1 ? 'solid 2px #F2553D' : '',
          height: '25px',
          background: '#ffffff',
        }"
      >
        未使用
      </div>
      <div
        class="tabs"
        @click="handleTab(2)"
        :style="{
          color: active === 2 ? '#F2553D' : '#757575',
          borderBottom: active === 2 ? 'solid 2px #F2553D' : '',
          height: '25px',
        }"
      >
        已使用
      </div>
      <div
        class="tabs"
        @click="handleTab(3)"
        :style="{
          color: active === 3 ? '#F2553D' : '#757575',
          borderBottom: active === 3 ? 'solid 2px #F2553D' : '',
          height: '25px',
        }"
      >
        已过期
      </div>
    </div>
    <div class="wrapper">
      <!-- 未使用 -->
      <div
        class="noUse_item"
        v-if="active == 1"
        v-for="(item, index) of noUse"
        :key="item.id"
      >
        <div class="noUse_top">
          <div class="noUse_topOne">
            <p class="noUse_num">
              ￥<span>{{ item.coupon.discountRule.discount }}</span>
            </p>
            <p class="noUse_canUse">优惠券</p>
          </div>
          <div>
            <p class="noUse_center">{{ item.coupon.name }}</p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 2"
            >
              领取后{{ item.coupon.validPeriodRule.duration }}天内有效
            </p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 2"
            >
              <!--  hh:mm:ss -->
              {{ moment(item.collectedAt).format('YYYY-MM-DD') }}-
              {{ getCollectedValidTo(item) }}
            </p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 1"
            >
              <!--  hh:mm:ss -->
              {{
                moment(item.coupon.validPeriodRule.from).format('YYYY-MM-DD')
              }}-
              {{ moment(item.coupon.validPeriodRule.to).format('YYYY-MM-DD') }}
            </p>
            <p class="userules" @click="showDetail(item)">使用规则></p>
          </div>
          <div
            class="useButton"
            @click="handleClick(item)"
            v-if="item.status != 3"
          >
            立即使用
          </div>
          <div class="useButton usedButton" v-if="item.status == 3">未生效</div>

          <!-- <router-link to="/PaymentCode" class="useButton">
            立即使用
          </router-link> -->
        </div>
        <!-- <hr class="line" /> -->

        <!-- <p class="useRules">限{{ item.coupon.rules }}使用</p> -->
      </div>
      <!-- 已使用 -->
      <div
        class="noUse_item"
        v-if="active == 2"
        v-for="item of used"
        :key="item.id"
      >
        <div class="noUse_top">
          <div class="noUse_topOne">
            <p class="noUse_num">
              ￥<span>{{ item.coupon.discountRule.discount }}</span>
            </p>
            <p class="noUse_canUse">优惠券</p>
          </div>
          <div>
            <p class="noUse_center">{{ item.coupon.name }}</p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 2"
            >
              领取后{{ item.coupon.validPeriodRule.duration }}天内有效
            </p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 2"
            >
              {{ moment(item.collectedAt).format('YYYY-MM-DD') }}-
              {{ getCollectedValidTo(item) }}
            </p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 1"
            >
              <!--  hh:mm:ss -->
              {{
                moment(item.coupon.validPeriodRule.from).format('YYYY-MM-DD')
              }}-
              {{ moment(item.coupon.validPeriodRule.to).format('YYYY-MM-DD') }}
            </p>
            <p class="userules" @click="showDetail(item)">使用规则></p>
          </div>
          <div class="useButton usedButton">已使用</div>
        </div>
        <!-- <hr class="line" /> -->
        <!-- <p class="useRules">{{ item.coupon.description }}</p> -->
        <!-- <p class="useRules">限{{ item.coupon.rules }}使用</p> -->
      </div>
      <!-- 已过期 -->
      <div
        class="noUse_item"
        v-if="active == 3"
        v-for="item of pass"
        :key="item.id"
      >
        <div class="noUse_top">
          <div class="noUse_topOne">
            <p class="noUse_num">
              ￥<span>{{ item.coupon.discountRule.discount }}</span>
            </p>
            <p class="noUse_canUse">优惠券</p>
          </div>
          <!-- <div class="noUse_topOne" v-if="item.coupon.discountRule.rebate > 0">
          <p class="noUse_num" style="padding-bottom:.3rem;margin-top:.2rem">
            <span>{{ item.coupon.discountRule.rebate }}折</span>
          </p>

        </div> -->
          <div>
            <p class="noUse_center">{{ item.coupon.name }}</p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 2"
            >
              领取后{{ item.coupon.validPeriodRule.duration }}天内有效
            </p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 2"
            >
              {{ moment(item.collectedAt).format('YYYY-MM-DD') }}-
              {{ getCollectedValidTo(item) }}
            </p>
            <p
              class="noUse_centerTime"
              v-show="item.coupon.validPeriodType === 1"
            >
              <!--  hh:mm:ss -->
              {{
                moment(item.coupon.validPeriodRule.from).format('YYYY-MM-DD')
              }}-
              {{ moment(item.coupon.validPeriodRule.to).format('YYYY-MM-DD') }}
            </p>
            <p class="userules" @click="showDetail(item)">使用规则></p>
          </div>
          <div class="useButton usedButton">已过期</div>
        </div>
        <!-- <hr class="line" /> -->
        <!-- <p class="useRules">{{ item.coupon.description }}</p> -->
        <!-- <p class="useRules">限{{ item.coupon.rules }}使用</p> -->
      </div>
    </div>

    <!-- <div style="height:50px"></div> -->
    <div v-if="details" class="mask"></div>
    <div v-if="details" class="detail_box">
      <p class="usetit">使用规则</p>
      <div class="detail_content">
        <p v-if="rules" class="detail_p">{{ rules }}</p>
        <p v-if="desc" class="detail_p">{{ desc }}</p>
        <p v-if="shops" class="detail_p">{{ shops }}</p>
      </div>
      <p class="agree" @click="agrees()">我知道了</p>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'mycoupon',
  data() {
    return {
      logoUrl: '/static/image/jilu.png',
      active: 1,
      noUse: [],
      used: [],
      pass: [],
      details: false,
      rules: '',
      desc: '',
      shops: '',
      showQR: false,
      qrcode: null,
    }
  },
  mounted() {
    const openId = localStorage.getItem('code')
    const cardNo = localStorage.getItem('VIPNO')
    this.RequestVIP(
      `h5/coupon/all?openID=${openId}&cardNo=${cardNo}&comID=${localStorage.getItem(
        'companyID'
      )}`,
      (r) => {
        let data = r.data.data.result
        // 店铺

        this.RequestVIP(
          'h5/shop/all?page=1&size=999',
          (res) => {
            const { result } = res.data.data
            let arr = []
            data.map((item, idx) => {
              result.map((it) => {
                // console.log(item.coupon.shops, "ssssssss");
                if (
                  item.coupon.shops !== null &&
                  item.coupon.shops.indexOf(it.id) > -1
                ) {
                  // console.log(it.name);
                  arr[idx] = arr[idx] ? arr[idx] + ',' + it.name : it.name
                }
              })
            })
            // setTimeout(() => {
            // console.log(arr, data, "arrrrrrrrrrrr");
            // }, 3000);
            data &&
              data.map((i, index) => {
                i.coupon.rules = arr[index]
              })
            this.noUse =
              data.length &&
              data.filter((item) => {
                return (
                  (item.status == 1 && item.isUsed == false) || item.status == 3
                )
              })
            this.used =
              data.length &&
              data.filter((item) => {
                return item.isUsed == true
              })
            this.pass =
              data.length &&
              data.filter((item) => {
                return item.status == 2
              })
          },
          (err) => console.log
        )
        this.initQrcode()
        // console.log(this.noUse, this.used, "iususdjkkslfklsdmf");
      },
      (err) => console.log(err)
    )
  },
  methods: {
    initQrcode() {
      this.qrcode = new QRCode('qrcode', {
        width: 180,
        height: 180,
        correctLevel: QRCode.CorrectLevel.L,
      })
    },
    handleClose() {
      this.showQR = false
    },
    toASCII(str) {
      let code = ''
      for (let i = str.length - 1; i >= 0; i--) {
        code += str.charCodeAt(i)
        code += i === 0 ? '' : ','
      }
      return code
    },
    handleClick(item) {
      console.log(this.qrcode, 'QRCodeQRCode')
      let qr = `${item.id}`
      // let qr = this.toASCII(`id=${item.id}&code=${localStorage.getItem('code')}`)
      // this.qrcode.makeCode(encodeURIComponent(`id=${item.id}&code=${localStorage.getItem('code')}`))
      this.qrcode.makeCode(qr)
      this.showQR = true
    },
    handleTab(index) {
      this.active = index
    },
    getCollectedValidTo(item) {
      if (!item || !item.collectedAt) {
        return ''
      }
      const duration =
        Number(
          item.coupon &&
            item.coupon.validPeriodRule &&
            item.coupon.validPeriodRule.duration
        ) || 0
      return this.moment(item.collectedAt)
        .add(duration * 24, 'hours')
        .format('YYYY-MM-DD')
    },
    showDetail(item) {
      this.shops = '限用店铺:' + item.coupon.rules
      this.desc = '卡券说明:' + item.coupon.description
      if (
        item.coupon.discountRule.spendSatisfy == 0 &&
        item.coupon.discountRule.goodsSumSatisfy == 0
      ) {
        this.rules = '使用规则：无门槛使用'
      } else {
        this.rules = `使用规则：满${
          item.coupon.discountRule && item.coupon.discountRule.spendSatisfy
            ? item.coupon.discountRule.spendSatisfy + '元'
            : 0 + '元'
        }，${
          item.coupon.discountRule && item.coupon.discountRule.goodsSumSatisfy
            ? item.coupon.discountRule.goodsSumSatisfy + '件'
            : 0 + '件'
        }可用`
      }
      this.details = true
      // console.log(data, "dadadaaddadadad");
    },
    agrees() {
      this.details = false
    },
  },
}
</script>
<style scoped>
.mycoupon {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
}

.titles {
  width: 100%;
  height: 25px;
  min-height: 25px;
  line-height: 25px;
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  box-sizing: border-box;
  background: #ffffff;
  font-size: 10px;
  color: #757575;
  position: absolute;
  top: 0;
  z-index: 9999999;
}

.tabs {
  width: 30%;
  height: 25px;
  min-height: 25px;
  text-align: center;
  position: relative;
  z-index: 999999999;
}

.wrapper {
  width: 100%;
  height: calc(100vh - 30px);
  position: absolute;
  top: 30px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.noUse_topOne {
  padding-right: 10px;
  border-right: dotted 1.2px #e0e0e0;
}

.noUse_item {
  width: 233px;
  /* height: 83px; */
  background: #ffffff;
  /* border: 1px solid #eeeeee; */
  opacity: 1;
  margin: 11px 0 0 8px;
}

.noUse_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 12px 10px 6px;
  box-sizing: border-box;
}

.noUse_num {
  font-size: 9px;
  color: #f2553d;
  line-height: 23px;
}

.noUse_num span {
  font-size: 14px;
  font-weight: 900;
}

.noUse_canUse {
  font-size: 8px;
  line-height: 12px;
  height: 19px;
  color: #f2553d;
}

.noUse_center {
  width: 110px;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  /* height: 44px; */
  color: #757575;
}

.noUse_centerTime {
  width: 100px;
  overflow: hidden;
  height: 10px;
  font-size: 8px;
  font-weight: 400;
  line-height: 10px;
  color: #9e9e9e;
}

.useButton {
  width: 47px;
  height: 17px;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  opacity: 1;
  border-radius: 15px;
  font-size: 8px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 17px;
  margin-top: 14px;
  text-decoration: none;
}

.usedButton {
  background: lightgray;
}

.useRules {
  height: 23px;
  line-height: 23px;
  box-sizing: border-box;
  padding: 0 8px;
  color: #9e9e9e;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.useRulesOpen {
  line-height: 12px;
  box-sizing: border-box;
  padding: 0 8px;
  color: #9e9e9e;
  width: 100%;
}

.line {
  border: none;
  height: 1px;
  background: #eeeeee;
}

.userules {
  color: #757575;
  font-size: 8px;
  margin-top: 2px;
}

.detail_box {
  width: 70%;
  min-height: 150px;
  max-height: 300px;
  font-size: 10px;
  font-weight: 400;
  color: #757575;
  background: white;
  position: fixed;
  top: 20%;
  left: 15%;
  z-index: 1000;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
  padding-bottom: 34px;
}

.detail_content {
  max-height: 198px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.agree {
  width: 100%;
  height: 28px;
  line-height: 28px;
  color: white;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  position: absolute;
  bottom: 0;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
}

.detail_p {
  margin: 8px 10px;
  font-size: 10px;
  font-weight: 400;
  line-height: 17px;
  color: #757575;
  word-break: break-word;
}

.detail_p + .detail_p {
  margin-top: 10px;
}

.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(15, 23, 42, 0.42);
}

.maskqr {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999999999999;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.4;
}

.usetit {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #424242;
  width: 100%;
  margin: 12px 0 10px;
  text-align: center;
}

#qrcode {
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  z-index: 999999999999;
  box-sizing: border-box;
  padding-left: calc(63vw - 90px);
  padding-top: calc(40vh - 90px);
}
</style>



// WEBPACK FOOTER //
// src/MyCoupon/index.vue